import { z } from "zod";
const CoinJSONSchema = z.object({
  balance: z.string(),
  coinType: z.string()
});
const AssetsResponseSchema = z.object({
  baseTokens: z.string(),
  nativeTokens: z.array(CoinJSONSchema)
});
export {
  AssetsResponseSchema,
  CoinJSONSchema
};
//# sourceMappingURL=assetsResponse.js.map
